import React from "react";

const HandleSelectColumnName = (columns) => {
    return columns
        .map(col => {
            if (React.isValidElement(col.name) && col.name.props?.headerName) {
                return {
                    headerName: col.name.props.headerName,
                    key: col.key
                };
            }
            return null;
        })
        .filter(Boolean);
};

export default HandleSelectColumnName;
